/* @refresh reload */
import { render } from 'solid-js/web';
import './index.css';
import './assets/styles.less';
import App from './App';
const baseUrl = (document.getElementById("solid-api-base-url") as HTMLInputElement)?.value;
const isLoggedIn = (document.getElementById("solid-is-logged-in") as HTMLInputElement)?.value === "true";
const artist = JSON.parse((document.getElementById("solid-artist") as HTMLInputElement)?.innerHTML || "{}");
const googleMapsApiKey = (document.getElementById("solid-google-maps-api-key") as HTMLInputElement)?.value
const settings = JSON.parse((document.getElementById("solid-settings") as HTMLScriptElement)?.textContent || "{}");
render(() => <App
    baseUrl={baseUrl}
    settings={settings}
    artist={artist}
    isLoggedIn={isLoggedIn}
    googleMapsApiKey={googleMapsApiKey}
/>, document.getElementById('root'));